fragment SmallTopicFeatureBoxFragment on smallTopicFeatureBox_Entry {
  id
  typeHandle
  heading
  cta {
    ...LinkFragment
  }
  topics: smallTopicFeatureBoxTopics {
    ... on topicsBlock_Entry {
      heading
      image {
        url
        title
      }
      body
      cta {
        ...LinkFragment
      }
      entry {
        ... on topic_Entry {
          title
          categories: knowledgeCategories {
            id
            title
            slug
          }
        }
      }
    }
  }
}
